import $ from 'jquery'
import {InitBurger} from './components/burger_menu.js'
import {InitSelectSliders} from "./components/select_year_slider.js";

$(function(){
    InitBurger()
    InitSelectSliders()
})()
